import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Header from "../components/ContainerHeader";
import Form from "../components/serverFound/Form";

import { setActiveHost } from "../actions/activeActions";

const ServerFound = ({ history, activeHost }) => {
  if (activeHost)
    return (
      <div className="flex-col">
        <Header title="Založit nový server" />
        <Form hostId={activeHost.id} history={history} />
      </div>
    );

  return <div />;
};

export default compose(
  connect(({ active: { activeHost } }) => ({ activeHost }), { setActiveHost }),
  lifecycle({
    componentWillMount() {
      const { activeHost, history } = this.props;

      if (!activeHost) {
        history.push("/hosts");
      }
    },
    componentWillUnmount() {
      const { setActiveHost } = this.props;

      setActiveHost(null);
    }
  })
)(ServerFound);



// WEBPACK FOOTER //
// ./src/pages/ServerFound.js